import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Quote, ArrowRight } from "lucide-react";

const testimonials = [
  {
    name: "Michelle and Ron",
    content: "My family and I have had the wonderful opportunity to visit there many times over the last 15 years or so, and never thought we would be able to have a home there. Tammy Donnelly helped make it happen. Tammy, who grew up in the Virgin Islands, was extremely informative, providing us with everything we needed to know to move forward with the purchase of an island home. She made herself available to show us the properties we had interest in, to answer questions, and to provide us with names, documents and instructions on all the steps involved. She made the distance between the island and the states seem nonexistant as we proceeded with the purchase and closing from our New York state home. Tammys' assistance did not end with the closing. Tammy continued her support, when ever asked, with professionalism and timelyness. Since we are not quite ready to retire and leave our home in the states, Tammy has helped us prepare our island home for short term rentals. Tammy has been instrumental in adding all finishing touches to our villa, and has introduced it to her website. We enjoy the positive comments from our satisfied guests on not only the villa, but Tammys' timely, informative and friendly service. The 340 Real Estate Company is, in our opinion, one of the best sites we have seen. It is straight forward, informative, and friendly, much like Tammy herself. It is one of the few sites that allows you to put in your own criteria to search properties, and show you its actual location on the island. I urge anyone who is thinking about making the move to St John to go to www.340realestateco.com and contact Tammy Donnelly. She made it happen for us, and she can make it happen for you.",
  },
  {
    name: "Lisa Pollack",
    content: "We could not be more pleased by our experience with Tammy as our realtor. It is all thanks to her professionalism, breadth of knowledge, work ethic, patience, intuition and attention to detail that we are happy home owners in St. John. She assessed us and our needs immediately and contoured our search in the best way possible to not waste our time or her own. There was efficiency and respect to the process combined with incredible warmth and understanding. Tammy could not have been more helpful, knowledgable or supportive. She sets the bar high and we could not recommend her more wholeheartedly for a superlative real estate experience.",
  },
  {
    name: "Bill",
    content: "How often can you say that your realtor has become a good friend. Tammy knows the island as well as anyone. She listened to us and understood us very well, such that she showed us our home, which we love, on the very first day of looking. She was very patient with us, never tried to \"sell us up\", and was very detail oriented when it came to completing our transaction.",
  },
];

const TestimonialCard = ({ testimonial, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isLongText = testimonial.content.length > 280;
  const displayText = isExpanded ? testimonial.content : testimonial.content.slice(0, 280) + "...";

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.2 }}
      className="bg-white rounded-3xl p-8 lg:p-10 shadow-2xl border border-gray-100 flex flex-col relative h-full"
    >
      <div className="text-tropical-500 mb-6">
        <Quote className="w-10 h-10 fill-current opacity-20" />
      </div>

      <div className="flex-grow">
        <p className="text-ink-700 font-light leading-relaxed mb-6 text-lg">
          {isLongText ? displayText : testimonial.content}
        </p>
      </div>

      <div className="mt-auto pt-6 border-t border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="text-ink-900 font-bold font-display">{testimonial.name}</h4>
            <p className="text-ink-400 text-sm">Verified Client</p>
          </div>
          {isLongText && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-tropical-600 font-bold text-sm hover:text-tropical-700 transition-colors"
            >
              {isExpanded ? "Show Less" : "Read More"}
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

const Testimonials = () => {
  return (
    <section className="py-24 lg:py-32 bg-gray-200 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 lg:mb-24">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-sm font-semibold tracking-widest uppercase text-tropical-500 mb-3 font-display"
          >
            Testimonials
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-4xl sm:text-5xl font-bold tracking-tight text-ink-900 font-display"
          >
            What our clients are saying
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} testimonial={t} index={i} />
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="text-center mt-16"
        >
          <Link
            to="/testimonials"
            className="inline-flex items-center gap-2 px-8 py-4 bg-ink-900 text-white text-sm font-bold rounded-full hover:bg-ink-800 transition-transform hover:scale-105 duration-300 shadow-md group"
          >
            View More Testimonials <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
